import { useState } from "react";
import styles from "./CityAvatar.module.scss";

const AVATAR_COLORS = [
  "#ffe0e6",
  "#ffe1cc",
  "#fde2ff",
  "#dff5e1",
  "#dbe9ff",
  "#fff3cf",
];

function hashString(value: string) {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

type IconAvatarProps = {
  label: string;
  icon: React.ReactNode;
};

function IconAvatar({ label, icon }: IconAvatarProps) {
  const color = AVATAR_COLORS[hashString(label) % AVATAR_COLORS.length];
  return (
    <span className={styles.CityAvatar} style={{ backgroundColor: color }}>
      {icon}
    </span>
  );
}

type CityAvatarProps = {
  label: string;
  navImageUrl?: string | null;
  icon: React.ReactNode;
};

export default function CityAvatar({
  label,
  navImageUrl,
  icon,
}: CityAvatarProps) {
  const [imageFailed, setImageFailed] = useState(false);

  if (navImageUrl && !imageFailed) {
    return (
      <span className={styles.CityAvatar}>
        <img
          src={navImageUrl.replace(
            "/upload/",
            "/upload/q_auto,f_webp,h_40,dpr_2/",
          )}
          alt={label}
          // The desktop destination menu renders these while hidden; lazy keeps
          // them from downloading on every page load.
          loading="lazy"
          className={styles.CityAvatarImage}
          onError={() => setImageFailed(true)}
        />
      </span>
    );
  }

  return <IconAvatar label={label} icon={icon} />;
}
